import qs from 'qs'
import initPreviewPlayer from './preview-player'
import { VOD_MESSAGE_TYPES } from '../../../constants'

const {
  CONTENT_HAS_ENDED,
} = VOD_MESSAGE_TYPES

try {
  const getStreamParams = () => {
    const {
      videoId,
      drmEnabled,
      videoGuid,
      title,
      genre,
      subGenre,
      videoLength,
    } = qs.parse(window.location.search, { ignoreQueryPrefix: true })

    return {
      videoId,
      drmEnabled,
      videoGuid,
      title,
      genre,
      subGenre,
      videoLength,
    }
  }

  initPreviewPlayer({
    selector: '#stv-preview-player',
    previewParams: getStreamParams(),
  })
} catch (error) {
  console.log(error) // eslint-disable-line no-console
  setInterval(() => {
    window.parent.postMessage({
      type: CONTENT_HAS_ENDED,
    }, '*')
  }, 7500)
}
